import { RolesEnum } from '../../types/enums/RolesEnum';

export const amIAllowed = (myRole: RolesEnum, requiredRole: RolesEnum) => {
  return parseInt(RolesEnum[myRole]) >= requiredRole;
};
